import { useEffect, useRef } from "react";
import { Modal,theme } from "antd";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";
import { useResumeStore } from "../store/resumeStore";

const RELOAD_WARN_ROUTES = new Set(["/resume/new", "/export"]);
const RELOAD_PATH_KEY = "__resume_reload_path__";

function getRouteLabel(pathname) {
  if (pathname === "/resume/new") return "Resume Builder";
  if (pathname === "/export") return "Preview & Download";
  return "this page";
}

export default function useReloadRedirect(options = {}) {
    const { useToken } = theme;
    const { token } = useToken();
  const { route = null, redirectOnOk = "/dashboard" } = options;
  const navigate = useNavigate();
  const location = useLocation();
  const navigationType = useNavigationType();
  const resetResume = useResumeStore((s) => s.resetResume);
  const modalOpened = useRef(false);
  const checkedOnce = useRef(false);

  useEffect(() => {
    const handleBeforeUnload = () => {
      const currentPath = window.location.pathname;

      if (RELOAD_WARN_ROUTES.has(currentPath)) {
        sessionStorage.setItem(RELOAD_PATH_KEY, currentPath);
      } else {
        sessionStorage.removeItem(RELOAD_PATH_KEY);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  useEffect(() => {
    if (modalOpened.current) return;
    if (checkedOnce.current) return;
    checkedOnce.current = true;

    const pathname = route || location.pathname;
    if (!RELOAD_WARN_ROUTES.has(pathname)) return;

    const navEntry = performance.getEntriesByType("navigation")[0];
    const isReload = navEntry && navEntry.type === "reload";
    const reloadedPath = sessionStorage.getItem(RELOAD_PATH_KEY);
    sessionStorage.removeItem(RELOAD_PATH_KEY);

    const isSameRouteReload = reloadedPath === pathname;
    const isInitialPopNavigation = navigationType === "POP";

    if (!isReload || !isSameRouteReload || !isInitialPopNavigation) return;

    modalOpened.current = true;

    const label = getRouteLabel(pathname);

    Modal.confirm({
  title: <span style={{ color: token.colorTextHeading }}>Reload detected</span>,
  content: (
    <span style={{ color: token.colorTextHeading }}>
      The page was refreshed on ${label}. What do you want to do?
    </span>
  ),
  okText: "Go to Dashboard",
  cancelText: "Stay Here",
  centered: true,
  okButtonProps: { style: { color: "#fff" } },
  // cancelButtonProps: { style: { color: "#fff" } },
  onOk() {
    resetResume();
    navigate(redirectOnOk, { replace: true });
    modalOpened.current = false;
  },
  onCancel() {
    modalOpened.current = false;
  }
});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, navigate, navigationType, redirectOnOk, resetResume, route]);
}
